import React from 'react'
import PropTypes from 'prop-types'

import Layout from '../components/Layout'
import { MetaData } from '../components/common/meta'

import Home from '../templates/Home'

function Landing({ location }) {
  return (
    <>
      <MetaData location={location} />
      <Layout>
        <Home />
      </Layout>
    </>
  )
}

Landing.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
}

export default Landing
